(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-products"]) return;
  try {
    
  function alignActiveCollectionChip(root) {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    root.querySelectorAll('.ac-collection-nav').forEach(function (nav) {
      var activeChip = nav.querySelector('.ac-collection-nav__link.is-active');
      if (!activeChip) return;

      requestAnimationFrame(function () {
        var targetLeft = activeChip.offsetLeft - (nav.clientWidth - activeChip.offsetWidth) / 2;
        nav.scrollTo({ left: Math.max(0, targetLeft), behavior: 'auto' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      alignActiveCollectionChip(document);
    });
  } else {
    alignActiveCollectionChip(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    alignActiveCollectionChip(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
